'use strict';
/* jshint ignore:start */

var impressionsModule = require('./impressions');

var addToCart = {
	addToBagEvent: function (e, giftCardAmount) {
		var cartObject = JSON.parse($('input[name=cartData]').val());
		var productObject = {};
		var image = '';
		var productUrl = '';
		if (e.currentTarget.dataset['gtmproduct'] !== undefined) {
			productObject = JSON.parse(e.currentTarget.dataset['gtmproduct']);
			image = $(e.currentTarget.closest('.content')).find('img').prop('src');
			productUrl = $(e.currentTarget.closest('.content')).find('.section-content').find('a').prop('href');
		} else {
			productObject = JSON.parse($('input[name=productData]').val());
			image = $('.primary-image').prop('src');
			productUrl = $(location).attr('href');
		}
		// handle gift card add to cart dynamic price
		if (productObject['giftCardType']) {
			productObject['price'] = giftCardAmount ? giftCardAmount : $('input.gift-cert-amount').val() || productObject['price'];
		}
		// if qty values missing populate it from qty selector
		if (!productObject['product_quantity']) {
			productObject['product_quantity'] = $('input[name=Quantity]').val() || 1;
		}
		if ($('input[name=currentHamper]').length > 0) {
			var hamperObject = JSON.parse($('input[name=currentHamper]').val());
		}
		// update product with impression list available
		if (!productObject['item_list_name']) {
			productObject['item_list_name'] = addToCart.getImpressionList(productObject.productID);
		}
		var obj = {
			'event': 'addToBag',
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name,
			'product': productObject,
			'voucher_ID': cartObject.voucher_ID,
			'voucher_total': cartObject.voucher_total,
			're_product_image': image,
			're_product_url': productUrl,
			're_tasting_club_product': productObject.re_tasting_club_product
		};

		if (hamperObject) {
			var objHamper = {
			'hamper_capacity': $('#currentHamperItemCount').text(),
			'hamper_items_added': $('#currentHamperItemCount').text(),
			'hamper_name': hamperObject.name,
			'hamper_price': hamperObject.hamper_price,
			'hamper_quantity': hamperObject.hamper_quantity,
			'hamper_size': hamperObject.hamper_size,
			'hamper_sku': hamperObject.hamper_sku,
			'hamper_type': hamperObject.hamper_type
			};
			$.extend(obj, objHamper);
		}
		dataLayer.push(obj);
	},

	boxAddedToBasket: function (e) {
		var cartObject = JSON.parse($('input[name=cartData]').val());
		var obj = {
			'event': 'Box added to basket',
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name,
			'hamper_capacity': cartObject.hamper_capacity,
			'hamper_items_added': cartObject.hamper_items_added,
			'hamper_name': cartObject.hamper_name,
			'hamper_price': cartObject.hamper_price,
			'hamper_quantity': cartObject.hamper_quantity,
			'hamper_size': cartObject.hamper_size,
			'hamper_SKU':  cartObject.hamper_SKU,
			'hamper_type':  cartObject.hamper_type,
			'order_clear_bag': cartObject.order_clear_bag,
			'order_delivery_total': cartObject.order_delivery_total,
			'order_delivery_type': cartObject.order_delivery_type,
			'order_discount_member_ID': cartObject.order_discount_member_ID,
			'order_discount_member_value': cartObject.order_discount_member_value,
			'order_discount_product_ID': cartObject.order_discount_product_ID,
			'order_discount_product_value': cartObject.order_discount_product_value,
			'order_discount_voucher_ID': cartObject.order_discount_voucher_ID,
			'order_discount_voucher_value': cartObject.order_discount_voucher_value,
			'order_gifting_total': cartObject.order_gifting_total,
			'order_gifting_type': cartObject.order_gifting_type,
			'order_item_quantity': cartObject.order_item_quantity,
			'order_items_total': cartObject.order_items_total,
			'order_payment_method': cartObject.order_payment_method,
			'order_total_price': cartObject.order_total_price ? cartObject.order_total_price : 0.0,
			'product': cartObject.product,
			'voucher_ID': cartObject.voucher_ID,
			'voucher_total': cartObject.voucher_total,
			're_product_image': cartObject.re_product_image,
			're_product_url': cartObject.re_product_url,
			're_tasting_club_product': cartObject.re_tasting_club_product
		};
		dataLayer.push(obj);
	},
	// determine latest impression list for this product in a safe way
	getImpressionList: function (productID) {
		try {
			const productName = $('[itemprop="name"]').text() || '';
			return impressionsModule.getLastImpressionList(productID, productName);
		} catch(e) {
			window.console.warn(e);
		}
		return 'OTHER';
	}
}
module.exports = addToCart
/* jshint ignore:end */
